import { render, staticRenderFns } from "./LawSecurityDepositClientRefundMethodList.vue?vue&type=template&id=a51bfcca&"
import script from "./LawSecurityDepositClientRefundMethodList.vue?vue&type=script&lang=js&"
export * from "./LawSecurityDepositClientRefundMethodList.vue?vue&type=script&lang=js&"
import style0 from "./LawSecurityDepositClientRefundMethodList.vue?vue&type=style&index=0&id=a51bfcca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports